import { farmListFilter } from '@/store/farms/types';

export default {
  farmsContext: [],
  status: '',
  createStatus: '',
  deleteStatus: '',
  farmListContext: [],
  farmListStatus: '',
  farmListFilter: localStorage.getItem(farmListFilter) ? JSON.parse(localStorage.getItem(farmListFilter)!) : null,
};
